export enum WeightCategory {
  TTS = "text_to_speech",
  VOCODER = "vocoder",
  VC = "voice_conversion",
  ZS = "zero_shot",
  SD = "image_generation",
  WF = "workflow_config",
}
